import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Controller from "csi/action/Controller";
import csi from "csi/main";
import Delete from "csi/table/Delete";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import PostRequest from "csi/comm/PostRequest";
import xml from "csi/xml";

const DeleteThemeStyle = declare(Delete, {

	confirmAction: function(params:Object) {
		this.setProgress();
		new PostRequest("Specification", "ValidateThemeStyleDS")
			.addParameter(xml.PROP_URL_PARENT, this.m_urlNode)
			.post({})
			.then(lang.hitch(this, this._onValidateResponse));
	},

	_onValidateResponse: function(response: any) {
		if (response.getReturnValue()) {
			this._confirm("WARNING", "Style", "RemoveStyleFromTheme_Confirm");
		} else {
			this._confirm("WARNING", "Style", "RemoveStyleFromThemeNoLinked_Confirm");
		}
	},

	onConfirm: function(key: string) {
		// summary: cancel, go to request directly or open Style Size Chart dimensions view popup TA27834
		if (key == MessageDialog.BUTTON_CANCEL) {
			this.postProcess();
		} else if (key == MessageDialog.BUTTON_REMOVE) {
			this.process();
		} else {
			// the delete action always has a confirmation dialog, thus its preProcess opens Confirmation Dialog
			// therefore calling preProcess of Action Controller to popup the view with Style Size Chart dimensions
			Controller.prototype.preProcess.call(this);
		}
	},

	toWriter: function() {
		this.m_writer.changeNode(this.m_urlNode).changeAttribute("Theme", xml.ATTR_REF, csi.EMPTY_URL);
	},

	_confirm: function(titleKey: string, messageKey: string, localeMsg: string) {
		Controller.prototype.confirmAction.call(this, {
			materialIcon: MessageDialog.ICON_WARNING,
			buttons: [MessageDialog.BUTTON_REMOVE, MessageDialog.BUTTON_CANCEL],
			message: locale.typeAction(messageKey, localeMsg),
			title: locale.resource(titleKey),
		});
	},
});

export = DeleteThemeStyle;